export default __webpack_public_path__ + "static/wave_assert_repeatition-8895c7429addbbba067fe6a57b772b35.png";